import { compose, getContext, withHandlers } from 'recompose';
import { contextTypes, ILassoContext } from '../Lasso.types';
import { IInner, IOuter } from './LassoItem.types';
import withLifecycle from '@hocs/with-lifecycle';

export const enhance = compose<IInner, IOuter>(
  getContext<ILassoContext>(contextTypes),
  withHandlers({
    saveRef:
      ({ onLassoItemReady, itemId }) =>
      (node) => {
        if (!node) {
          return;
        }

        if (onLassoItemReady) {
          onLassoItemReady(itemId, node);
        }
      },
  }),
  withLifecycle({
    onWillUnmount({ onLassoItemDestroy, itemId }) {
      if (onLassoItemDestroy) {
        onLassoItemDestroy(itemId);
      }
    },
  }),
);
